import Vue from 'vue'
import Vuex from 'vuex'
import authModules from './modules/auth';
import sheetModules from './modules/sheet';

Vue.use(Vuex)

export default new Vuex.Store({
    modules :{
        auth : authModules,
        sheet : sheetModules,
    },
});


// WEBPACK FOOTER //
// ./src/store/index.js